import { apiServer } from "../config/config";
import { LoginError } from "./auth";

export interface EmailCheckResult {
  data: {
    id: number;
    email: string;
    email_verification: number;
    first_name: string;
    last_name: string;
    profile_photo: string;
  } | null;
  status: string;
  message: string;
  registerEmail?: string;
  social_status?:string;
  /** Social provider the email is registered with (lowercased: apple/google/facebook),
   *  returned when social_status === "success". Drives account_login_failed.auth_provider. */
  provider?: string;
}

export async function checkEmail(email: string): Promise<EmailCheckResult> {
  const emailData = { email };
  const response = await fetch(apiServer + "/user/check-email-exist", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify(emailData),
  });

  if (!response.ok) {
    // A lockout answers 429 with the login envelope. Keep its message and
    // code so callers can show the wait instead of a generic failure.
    const body = await response.json().catch(() => null);

    if (typeof body?.message === "string" && typeof body?.code === "string") {
      throw new LoginError(body.message, body.code, body.data);
    }

    throw new Error(`Failed to check email: ${response.status}`);
  }

  const responseData = await response.json();
  return responseData;
}
